module.exports = __webpack_public_path__ + "img/1F492.6a25d637.svg";